<template>
  <div class="main-page" :key="keypage">
    <Menus :title="title" :border="true">
      <a href="javascript:void(0)" @click="goback">
        <div class="img_block">
          <img class="img_margin" :src="`${$root.statics}/img/icon/back_white.png`" alt="返回" />
        </div>
        <span>返回</span>
      </a>
    </Menus>
    <div class="container-flex_content">

      <!-- 接通律师/ 通话中 -->
      <div v-show="step === 1 || step === 2" class="content">
        <div class="videoconsult" v-show="step == 1">
          <div class="default-lawyer"></div>
        </div>
        <div class="videoconsult" v-show="step === 2">
          <div id="lawyer" class="target-video-container">
            <video class="video2" autoplay ref="targetVideo" />
          </div>
          <div id="person" class="self-video-container" ref="self-video-container">
            <video class="video3" autoplay ref="selfVideo" muted />
          </div>
        </div>

        <div class="intro" v-if="step === 1">
          <div class="info">
            服务时间：周一 ~ 周五（工作时间）
            <br />
            <div class="tip" v-if="isconnecting">
              正在接通{{ people }}，请稍等...
            </div>
            <span style="color: red;font-size:0.3rem;" v-if="alert.info">
              <br />
              {{ alert.info }}
            </span>
          </div>
          <div class="btns">
            <button class="button " @click="demoCall(cid)">开始咨询</button>
          </div>
        </div>
        <div v-if="step === 2" class="intro">
          <!-- <div class="lawyer">
            张小明
            <span>律师</span>
          </div>
          <div class="organ">
            三亚市公共法律服务中心
          </div>-->
          <div class="voicestatus">
            服务时间：周一 ~ 周五（工作时间）
            <br />
            通话中：
            <span>{{ timed }}</span>
          </div>
          <div class="btns">
            <button class="button active" @click="hangup">挂断</button>
          </div>
        </div>
      </div>
      <!-- 评价 -->
      <div v-if="step === 3" class="content">
        <div class="evaluation">
          <div class="title">您好，本次咨询结束，欢迎下次咨询！</div>
          <!-- <div class="voicetime">
            通话结束：
            <span>{{ timed }}</span>
          </div>
          <div class="evaluation-con">
            <div
              class="item"
              :class="{'active' : currentStars==5}"
              @click="currentStars=5"
            >
              <div class="imgs">
                <img
                  :src="`${$root.statics}/img/icon/lawyerconsult/e1.png`"
                  alt
                >
              </div>非常满意
            </div>
            <div
              class="item"
              :class="{'active' : currentStars==4}"
              @click="currentStars=4"
            >
              <div class="imgs">
                <img
                  :src="`${$root.statics}/img/icon/lawyerconsult/e2.png`"
                  alt
                >
              </div>满意
            </div>
            <div
              class="item"
              :class="{'active' : currentStars==3}"
              @click="currentStars=3"
            >
              <div class="imgs">
                <img
                  :src="`${$root.statics}/img/icon/lawyerconsult/e3.png`"
                  alt
                >
              </div>一般
            </div>
            <div
              class="item"
              :class="{'active' :currentStars==2}"
              @click="currentStars=2"
            >
              <div class="imgs">
                <img
                  :src="`${$root.statics}/img/icon/lawyerconsult/e4.png`"
                  alt
                >
              </div>不满意
            </div>
          </div>
          <div
            class="button"
            @click="sendEvaluate"
          >
            评价
          </div>-->
        </div>
      </div>
      <!-- 评价完成-->
      <div v-if="step === 4" class="content">
        <div class="success-info">
          <div class="success-icon" />
          <div class="title">评价完成</div>
          <div class="desc">感谢您的使用，如需其他服务请”返回首页”选择</div>
        </div>
      </div>
    </div>
    <Dialogs v-model="dialog">
      <div class="body">
        <div class="item c1">
          <div class="title">请按依次上传相应材料</div>
          <div class="material">
            <div class="info">
              <span>提示：请将文件放入左下方扫描位置,点击扫描，所有文件扫描完成后点击提交全部材料按钮进行提交！</span>
              <button @click="getScanning">扫描</button>
            </div>
            <div id="scan" class="material-con" />
          </div>
        </div>
        <div class="item c2">
          <div class="title">已扫描资料</div>
          <div class="material">
            <div class="materimg">
              <template v-if="materiallist.length">
                <div v-for="(item, index) in materiallist" :key="'key-' + index" class="mater-img-item"
                  :class="[(index + 1) % 3 == 0 ? 'nomargin' : '']">
                  <div class="delete" @click="deletePhoto(index, materiallist)" />
                  <img :src="item" alt />
                </div>
              </template>
              <div v-else style="padding:0.3rem 0;color:#999;font-size:0.24rem">暂无</div>
            </div>
            <div class="button" @click="sendToLawyerClick(uploadedUrl)">提交全部材料</div>
            <div class="tipinfo">全部文件上传后点击”提交全部材料”完成申请</div>
          </div>
        </div>
      </div>
      <div class="closedialog" @click.stop="closeDialog">
        <img :src="`${$root.statics}/img/icon/close.png`" alt />
      </div>
    </Dialogs>
    <div v-if="infoupload" class="uploadinfo">
      <div class="masks" />
      <div class="infocontent">
        <div class="infotitle">提示</div>
        <div class="infotxt">{{ infouploadtxt }}</div>
        <button @click="closeUploadinfo">确定</button>
      </div>
    </div>
    <Alert v-if="alert.show" :info="alert.info" :recall="alert.recall" @setClose="value => alert.show = value" />
  </div>
</template>
<script>
/* eslint-disable */

import Menus from '@/components/Menu'
import Dialogs from '@/components/Dialog'
import { dataURLtoBlob, removeByValue } from '@/fun.js'
import Alert from '@/components/Alert'
import axios from 'axios'
// import easyrtc from 'easyrtc'
import { v4 as generateUUID } from 'uuid'
import WebRTCPlus from "webrtc-plus";
import emitter from '@/lib/event.js'

export default {
  components: {
    Menus,
    Dialogs,
    Alert
  },
  data () {
    return {
      title: '',
      step: 1,
      people: '',
      dialog: {
        show: false,
        title: '',
        addclass: 'voicedialog'
      },
      timed: '00:00:00',
      userIdCard: '',
      currentStars: '',
      materiallist: [],
      uploadedUrl: [],
      alert: {
        show: false,
        info: '',
        recall: () => { }
      },
      infoupload: false,
      infouploadtxt: '',
      evaluate: false,
      recordGUID: null,
      peopleStreamName: null,
      userGUID: null,
      busy: null, // 占线
      callTimer: null,
      videoSetting: {},
      inAudioSetting: {},
      outAudioSetting: {},
      cid: 2,
      isconnecting: false,
      webRTCPlus: null,
      localStream: null,
      currentVideoMessage: null,
      rtcConnect: -1,
      socket: null
    }
  },
  computed: {
    keypage () {
      return String(new Date())
    }
  },
  watch: {
    // step(val) {
    //   if (val === 3 || val === 4) {
    //     console.log("评价");
    //     this.$startListen();
    //   }
    // }
  },
  created () {
    this.initDeviceSettings()
  },
  async mounted () {
    this.title = this.$route.query.title || '视频咨询'
    this.people = this.$route.query.people || '律师'
    // this.init()
    const cid = this.$route.query.cid || 2
    if (this.$route.query.cid) {
      this.cid = this.$route.query.cid
    }
    document.querySelector('#waitAudio').pause()
    // this.demoCall(cid)

    this.webRTCPlus = new WebRTCPlus({
      role: "consumer",
      iceServers: [
        {
          // TODO: 后续需要替换为服务器API传回
          urls: "stun:106.53.211.2:3478",
        },
        {
          urls: "turn:106.53.211.2:3478",
          username: "lvpintrun",
          credential: "J2hdi62kf2ud",
        },
      ],
      signalingBindFunction: (data) => {
        this.$socket.sendSignal(data);
      },
    });
    this.webRTCPlus.errorFunction = (data) => {
      // Dialog.alert({ type: "danger", message: data.msg });
      this.alert.info = data.msg
      this.alert.show = true
    };

    this.webRTCPlus.connectStateChangeFunction = (status) => {
      switch (status) {
        case "new":
        case "checking":
          this.rtcConnect = 1;
          break;
        case "connected":
          this.rtcConnect = 2;
          break;
        case "disconnected":
          this.rtcConnect = 1;
          break;
        case "closed":
          this.rtcConnect = 0;
          break;
        case "failed":
          this.rtcConnect = 1;
          break;
        default:
          this.rtcConnect = 1;
          break;
      }
    };

    this.webRTCPlus.remoteStreamUpdateFunction = async (
      streams
    ) => {
      if (
        streams &&
        streams[0] &&
        this.$refs.targetVideo.srcObject !== streams[0]
      ) {
        this.step = 2
        this.$nextTick(() => {
          document.querySelector('#waitAudio').pause()
        })
        this.$refs['self-video-container'].style.width = '200px'
        this.$refs['self-video-container'].style.height = 'auto'
        this.$refs.targetVideo.srcObject = streams[0];
        await this.$refs.targetVideo.play();
        this.startTimed()
      }
    };

    this.$socket.signalUpdate = (data) => {
      this.webRTCPlus.signal(data);
    };

    emitter.on('rtc', (data) => {
      if (!this.currentVideoMessage) {
        this.currentVideoMessage = data
      } else {
        if (this.currentVideoMessage.uuid === data.uuid) {
          this.currentVideoMessage = data
        }
      }
      if (
        this.currentVideoMessage.attribute.status === 4 || // 发起请求主动挂断
        this.currentVideoMessage.attribute.status === 5 || // 收到请求被挂断
        this.currentVideoMessage.attribute.status === 6 || // 服务器：超时无人接听
        this.currentVideoMessage.attribute.status === 7 || // 服务器：无客服人员在线
        this.currentVideoMessage.attribute.status === 8 ||// 发起方客户端强制挂断
        this.currentVideoMessage.attribute.status === 9 || 
        this.currentVideoMessage.attribute.status === 10
      ) {
        this.$nextTick(() => {
          document.querySelector('#waitAudio').pause()
        })
        if (this.webRTCPlus) {
          this.webRTCPlus.hangup();
        }
        if (this.localStream) {
          this.localStream.getTracks().forEach((track) => {
            track.stop();
          })
          this.localStream = null
        }
      }
      if (this.currentVideoMessage.attribute.status === 5) {
        this.alert.info = '对方已挂断'
        this.alert.show = true
        this.step = 3
      } else if (this.currentVideoMessage.attribute.status === 4) {
        this.alert.info = '已挂断'
        this.alert.show = true
        this.step = 3
      } else if (this.currentVideoMessage.attribute.status === 6 || this.currentVideoMessage.attribute.status === 8) {
        this.alert.info = '暂时无人接听，请稍后再试'
        this.alert.show = true
        this.step = 1
        this.goback()
      } else if (this.currentVideoMessage.attribute.status === 7) {
        this.alert.info = '当前没有客服人员在线，请稍后再试'
        this.alert.show = true
        this.step = 1
        this.goback()
      } else if (this.currentVideoMessage.attribute.status === 9) {
        this.alert.info = '当前客服人员正忙， 请稍后再试'
        this.alert.show = true
        this.step = 1
        this.goback()
      } else if (this.currentVideoMessage.attribute.status === 10) {
        this.alert.info = this.currentVideoMessage.attribute.message || '未知错误'
        this.alert.show = true
        this.step = 1
        this.goback()
      }
      // if (
      //   this.currentVideoMessage.attribute.status === 4 ||
      //   this.currentVideoMessage.attribute.status === 5
      // ) {
      //   // 未接通对方就挂断
      //   this.$nextTick(() => {
      //     document.querySelector('#waitAudio').pause()
      //   })
      //   if (this.webRTCPlus) this.webRTCPlus.hangup()
      //   if (this.localStream) {
      //     this.localStream.getTracks().forEach((track) => {
      //       track.stop()
      //     })
      //     this.localStream = null
      //   }
      //   this.endSys(1)
      // }
    })
  },
  beforeDestroy () {
    document.querySelector('#waitAudio').pause()
    this.$rtc.reset()
  },
  beforeRouteLeave (to, from, next) {
    this.$destroy() // 销毁vue 实例
    next()
  },
  methods: {
    initDeviceSettings () {
      this.videoSetting = JSON.parse(window.localStorage.getItem('videoSetting') || '{}')
      this.inAudioSetting = JSON.parse(window.localStorage.getItem('inAudioSetting') || '{}')
      this.outAudioSetting = JSON.parse(window.localStorage.getItem('outAudioSetting') || '{}')
    },
    async demoCall () {
      let constraints = {
        audio: {
          noiseSuppression: true, // 降噪
          echoCancellation: true, // 回音消除
        },
        video: true,
      };
      try {
        this.localStream = await navigator.mediaDevices.getUserMedia(
          constraints
        );

        this.step = 2
        this.$refs['self-video-container'].style.width = '100%'
        this.$refs['self-video-container'].style.height = '100%'
        this.$refs.selfVideo.srcObject = this.localStream;
        await this.$refs.selfVideo.play();

        this.webRTCPlus.init([this.localStream]);

        this.$nextTick(() => {
          document.querySelector('#waitAudio').src = 'https://qiniu.terminal.laway.cn/wait.mp3'
          document.querySelector('#waitAudio').play()
        })

        const msg = {
          uuid: generateUUID(),
          content: "",
          attribute: {
            startTime: new Date(),
            endTime: null,
            callUser: "consumer",
            status: 0,
            connectType: true
          },
          type: 'rtc',
          roomName: window.roomName,
          sendTime: new Date(),
        };

        this.currentVideoMessage = msg

        this.$socket.emit("sendMsg", msg);
      } catch (err) {
        console.log(err)
        // 异常情况处理,MIC异常
        this.alert.info = "获取摄像头或麦克风权限失败"
        this.alert.show = true
      }
    },
    // async demoCall (cid = 0) {
    //   this.$nextTick(() => {
    //     document.querySelector('#waitAudio').src = 'https://qiniu.terminal.laway.cn/wait.mp3'
    //     document.querySelector('#waitAudio').play()
    //   })

    //   // 获取本地视频流
    //   this.alert.info = ''
    //   this.isconnecting = true
    //   const localStream = this.$rtc.getLocalStream()
    //   if (localStream) {
    //     // 将本地视频流加载到dom
    //     const targetVideo = this.$refs.targetVideo
    //     targetVideo.muted = true
    //     targetVideo.srcObject = localStream
    //     if (!targetVideo) {
    //       console.log('268', targetVideo)
    //     }
    //   } else {
    //     console.log('拿不到')
    //     // return
    //   }

    //   // 获取可以呼叫的律师
    //   let {
    //     data: { result: lawyers }
    //   } = await axios.get(
    //     'https://api.terminal.wulvshi.com/api-v2/channel/listLawyers',
    //     {
    //       params: {
    //         cid,
    //         code: window.localStorage.getItem('code')
    //       }
    //     }
    //   )

    //   if (lawyers.length === 0) {
    //     this.alert.info = `当前暂无${this.people}在线，请稍后再来`
    //     this.alert.show = true
    //   } else {
    //     // 去重
    //     lawyers = [...new Set((lawyers || []).map(item => item.userGUID))]

    //     // 视频接通事件
    //     this.$rtc.onStreamAccept(({ targetId, selfStream, targetStream }) => {
    //       this.nowEasyrtcid = targetId
    //       this.step = 2
    //       this.startTimed()
    //       setTimeout(async () => {
    //         const selfVideo = this.$refs.selfVideo
    //         // selfVideo.style ="transform: rotateY(180deg)"
    //         const targetVideo = this.$refs.targetVideo
    //         // const outAudioSetting = JSON.parse(window.localStorage.outAudioSetting)
    //         const audioOutputDevice = this.$rtc.getAudioOutputDevice()
    //         selfVideo.srcObject = selfStream
    //         // 远程摄像头
    //         targetVideo.srcObject = targetStream
    //         targetVideo.muted = false
    //         // 远程语音信息
    //         console.log('语音输出加载到：' + audioOutputDevice)
    //         await this.$jsMediaDevices.setOutAudioDevices(
    //           targetVideo,
    //           // outAudioSetting['microphone'].deviceId
    //           audioOutputDevice
    //         )

    //         // 开启数据传输频道
    //         this.initDataChannel()
    //       })
    //     })
    //     // 本地视频流加载成功
    //     this.$rtc.onLoadLocalStream(stream => {
    //       const selfVideo = this.$refs.selfVideo
    //       // 接通之前先显示自己
    //       const targetVideo = this.$refs.targetVideo
    //       console.log('this.$refs:', this.$refs)
    //       targetVideo.muted = true
    //       targetVideo.srcObject = stream
    //     })

    //     // 呼叫计时
    //     this.callTimer = setTimeout(() => {
    //       this.alert.info = '暂时无人接听，请稍后再试'
    //       this.alert.show = true
    //       this.isconnecting = false
    //       this.$rtc.reset()
    //       // setTimeout(() => {
    //       //   this.$router.go(-1)
    //       // }, 3000)
    //     }, 60 * 1000)
    //     try {
    //       // 传入呼叫的律师的uuid数组
    //       await this.$rtc.videoCall(lawyers)
    //       console.log('已接通，清空计时器')
    //       clearTimeout(this.callTimer)
    //       this.$rtc.onEnd(() => {
    //         this.hangup()
    //       })
    //     } catch (e) {
    //       console.log(e)

    //       if (e.code === 'NO_ANSWER' || e.code === 'NO_LAWYER' || e.code === 'NO_DEVICE') {
    //         if (e.code === 'NO_DEVICE') {
    //           this.alert.info = `没有摄像头，请接入设备`
    //           this.isconnecting = false
    //         }
    //         if (e.code === 'NO_ANSWER') {
    //           this.alert.info = '暂时无人接听，请稍后再试'
    //           this.isconnecting = false
    //         }
    //         if (e.code === 'NO_LAWYER') {
    //           this.alert.info = `暂时没有${this.people}在线，请稍后再试`
    //           this.isconnecting = false
    //         }

    //         this.alert.show = true
    //         this.$rtc.reset()
    //         clearTimeout(this.callTimer)

    //         // setTimeout(() => {
    //         //   clearTimeout(this.callTimer)
    //         //   this.$router.go(-1)
    //         // }, 3000)
    //       }
    //     }
    //   }
    //   this.$nextTick(() => {
    //     document.querySelector('#waitAudio').pause()
    //   })
    // },
    // 数据传输频道
    initDataChannel () {
      easyrtc.setPeerListener(async (who, msgType, content) => {
        console.log(who, msgType, content, '2setPeerListener')
        if (
          msgType === 'link' &&
          this.step !== 3 &&
          !this.recordGUID &&
          !this.userGUID
        ) {
          this.userGUID = content
          this.$requestService
            .post('/api/record/start', {
              userGUID: content, // 律师GUID
              customerID: this.userIdCard // 用户身份证号
            })
            .then(res => {
              console.log(res.data.result.recordGUID)
              this.recordGUID = res.data.result.recordGUID
              easyrtc.sendDataWS(who, 'link', {
                recordGUID: this.recordGUID,
                userIdCard: this.userIdCard,
                code: window.localStorage.code
              })
            })
            .catch(err => {
              console.log('recordstart失败')
              console.log(err)
            })
        }
        // 打开扫描仪
        if (msgType === 'showFileScan' && this.step === 2) {
          await this.scanstartVedio('scan')
          this.dialog.show = true
        }

        // 打印pdf
        if (msgType === 'print') {
          const res = JSON.parse(content)
          const printA4Name = window.localStorage.getItem('printA4Name')
          this.$electron.ipcRenderer.send('printRemoteFile', res.fileurl, printA4Name)
        }
      })
    },
    stopStreamedVideo (videoElem) {
      if (videoElem) {
        let stream = videoElem.srcObject
        let tracks = stream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        videoElem.srcObject = null
      }
    },
    closeUploadinfo () {
      this.infoupload = false
    },
    closeDialog () {
      // 关闭弹窗
      this.dialog.show = false
      this.$loading.hide()
      this.uploadedUrl = []
      this.materiallist = []
    },
    showScan () {
      this.dialog.show = true
      this.$nextTick(() => {
        this.scanstartVedio('scan')
      })
    },
    goback () {
      console.log(this.step, 'seppp')
      this.hangup()
      if (this.step === 4) {
        this.$router.push('/home')
      } else {
        this.$router.go(-1)
        setTimeout(() => {
          this.$scrollTo(0)
        }, 0)
      }
      this.step -= 1
    },
    init () {
      this.userIdCard = this.$store.state.user.idCardResult.id // 用户身份证

      this.closeAllLocalVideo()
      this.recordGUID = null
      this.userGUID = null
      this.nowEasyrtcid = null

      const outAudioSetting = JSON.parse(window.localStorage.outAudioSetting)
      this.outAudioSetting = outAudioSetting

      const videoSetting = JSON.parse(window.localStorage.videoSetting)
      this.videoSetting = videoSetting

      const printA4Name = window.localStorage.printA4Name; // eslint-disable-line

      this.$speak(
        `请使用设备侧方的话筒与${this.people}进行对话`,
        this.outAudioSetting['open'].deviceId
      )

      easyrtc.setStreamAcceptor((easyrtcid, stream, streamName) => {
        this.nowEasyrtcid = easyrtcid
        // easyrtc.setRoomApiField('default', 'on', 'ok')
        console.log('接线成功')
        this.nextStep(2)
        this.startTimed()
        // 远程摄像头
        this.addMediaStreamToDiv('lawyer', stream, streamName, false)
        console.log('accepted incoming stream with name ' + stream.streamName)
        console.log(
          'checking incoming ' +
          easyrtc.getNameOfRemoteStream(easyrtcid, stream)
        )
        this.busy = setInterval(() => {
          easyrtc.sendDataWS(
            {
              targetRoom: 'default'
            },
            'live',
            easyrtcid
          )
        }, 1000)
      })

      easyrtc.setPeerListener(async (who, msgType, content) => {
        console.log(who, msgType, content, '2setPeerListener')
        if (
          msgType === 'link' &&
          this.step !== 3 &&
          !this.recordGUID &&
          !this.userGUID
        ) {
          this.userGUID = content
          this.$requestService
            .post('/api/record/start', {
              userGUID: content, // 律师GUID
              customerID: this.userIdCard // 用户身份证号
            })
            .then(res => {
              console.log(res.data.result.recordGUID)
              this.recordGUID = res.data.result.recordGUID
              easyrtc.sendDataWS(who, 'link', {
                recordGUID: this.recordGUID,
                userIdCard: this.userIdCard,
                code: window.localStorage.code
              })
            })
            .catch(err => {
              console.log('recordstart失败')
              console.log(err)
            })
        }
        if (msgType === 'showFileScan' && this.step === 2) {
          this.dialog.show = true
        }

        if (msgType === 'print') {
          const res = JSON.parse(content)
        }
      })

      easyrtc.setOnStreamClosed((easyrtcid, stream, streamName) => {
        this.endSys()
      })

      easyrtc.setCallCancelled(easyrtcid => {
        // if (easyrtcid === callerPending) {
        //   // 等待中。。。
        // }
      })

      easyrtc.setAcceptChecker((easyrtcid, callback) => {
        console.log('收到请求 setAcceptChecker')
        console.log(easyrtcid)
        callback(true, easyrtc.getLocalMediaIds()); // eslint-disable-line
      })
      easyrtc.setSocketUrl('https://terminal.wulvshi.com/')
      easyrtc.enableVideo(true)
      easyrtc.enableVideoReceive(true)
      easyrtc.setVideoDims(640, 480)
      easyrtc.enableDebug(true)
      easyrtc.setAutoInitUserMedia(false)
      easyrtc.getVideoSourceList(videoSrcList => {
        this.startVedio('person', videoSetting['personA'].deviceId, 'person')
        this.scanstartVedio('scan')
      })
    },
    async addMediaStreamToDiv (divId, stream, streamName, isLocal) {
      const container = document.createElement('div')
      container.style.marginBottom = '10px'
      const video = document.createElement('video')
      video.width = 640
      video.height = 480
      video.muted = isLocal
      video.style.verticalAlign = 'middle'
      // 远程语音信息
      if (divId === 'lawyer') {
        await this.$jsMediaDevices.setOutAudioDevices(
          video,
          this.outAudioSetting['microphone'].deviceId
        )
      }
      container.appendChild(video)
      document.getElementById(divId).innerHTML = ''
      document.getElementById(divId).appendChild(container)
      video.autoplay = true
      easyrtc.setVideoObjectSrc(video, stream)
      return divId
    },
    endSys () {
      this.endTimed()
      window.clearInterval(this.busy)
      // this.disconnect()
      this.closeDialog()
      // easyrtc.closeLocalMediaStream()
      this.nextStep(3)
    },
    hangup () {
      // this.isconnecting = true
      // this.$rtc.reset()
      // this.endSys()
      document.querySelector('#waitAudio').pause()
      this.currentVideoMessage.attribute.endTime = new Date();
      if (
        this.currentVideoMessage &&
        this.currentVideoMessage.attribute.status === 0) {
        this.currentVideoMessage.attribute.status = 4;
        this.$socket.emit("updateMessageAttribute", {
          type: 'rtc',
          roomName: window.roomName,
          uuid: this.currentVideoMessage.uuid,
          attribute: this.currentVideoMessage.attribute,
        });
      }

      if (this.webRTCPlus) this.webRTCPlus.hangup();
      if (this.localStream) {
        this.localStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      this.endSys()
    },
    disconnect () {
      easyrtc.disconnect()
    },
    closeLocalVideo (streamName) {
      easyrtc.closeLocalStream(streamName)
    },
    async createLocalVideo (stream, streamName, action) {
      // 开启摄像头
      await this.addMediaStreamToDiv(action, stream, streamName, true)
    },
    startVedio (buttonLabel, videoId, type) {
      // 开启某个摄像头
      easyrtc.setVideoSource(videoId)
      console.log('开启摄像头')
      easyrtc.initMediaSource(
        async stream => {
          await this.createLocalVideo(stream, buttonLabel, type)
          easyrtc.connect(
            'terminal',
            easyrtcid => {
              console.log('I am ' + easyrtc.cleanId(easyrtcid))
            },
            (errorCode, message) => {
              console.log(errorCode, message)
            }
          )
          this.peopleStreamName = stream.streamName
        },
        function (errCode, errText) {
          console.log(errCode, errText)
        },
        type
      )
    },
    addStreamToCall (otherEasyrtcid, buttonLabel) {
      console.log('6asdadadas')
      easyrtc.addStreamToCall(otherEasyrtcid, buttonLabel, function (
        easyrtcid,
        streamName
      ) {
        console.log(
          'Informational',
          'other party ' + easyrtcid + ' acknowledges receiving ' + streamName
        )
      })
    },
    closeAllLocalVideo () {
      if (this.peopleStreamName) {
        this.closeLocalVideo(this.peopleStreamName)
      }

      const personVideo = document.getElementById('person')
      const lawyerVideo = document.getElementById('lawyer')
      if (
        personVideo &&
        personVideo.children[0] &&
        personVideo.children[0].getElementsByTagName('video')
      ) {
        this.stopStreamedVideo(
          personVideo.children[0].getElementsByTagName('video')[0]
        )
      }

      if (
        lawyerVideo &&
        lawyerVideo.children[0] &&
        lawyerVideo.children[0].getElementsByTagName('video')
      ) {
        this.stopStreamedVideo(
          lawyerVideo.children[0].getElementsByTagName('video')[0]
        )
      }

      const ids = ['person', 'people', 'file', 'scan']
      for (const i in ids) {
        if (document.getElementById(ids[i])) {
          document.getElementById(ids[i]).innerHTML = ''
        }
      }
    },
    nextStep (step) {
      if (step) {
        this.step = step
      } else {
        this.step++
      }
      if (this.step === 2) {
        const personElement = document.getElementById('person')
        personElement.style.width = '200px'
        personElement.style.height = '150px'
        const video = personElement.children[0].getElementsByTagName(
          'video'
        )[0]
        video.width = 200
        video.height = 150
      }
    },
    startTimed () {
      let c = 0
      this.interval = window.setInterval(() => {
        c++
        let hour = parseInt(c / 3600) // 小时数
        let min = parseInt(c / 60) // 分钟数
        if (min >= 60) {
          min = min % 60
        }
        let lastsecs = c % 60
        if (hour < 10) hour = '0' + hour
        if (min < 10) min = '0' + min
        if (lastsecs < 10) lastsecs = '0' + lastsecs
        this.timed = hour + ':' + min + ':' + lastsecs
      }, 1000)
    },
    endTimed () {
      window.clearInterval(this.interval)
    },
    async uploadImg (base64) {
      const blob = dataURLtoBlob(base64)
      const uploadUrl = 'https://api.terminal.wulvshi.com/api/upload/img'
      const fd = new window.FormData()
      fd.append('img', blob, 'a.jpeg')
      const response = await fetch(uploadUrl, { method: 'post', body: fd })
      if (response.status !== 200) {
        this.showMsg('上传失败，请重新上传')
      }
      const res = await response.json()
      if (res.status === 1) {
        return res.result.realPath
      } else {
        return false
      }
    },
    sendEvaluate () {
      if (!this.currentStars) {
        return
      }
      this.$requestService.post('/api/remark/add', {
        userGUID: this.userGUID, // 律师
        recordGUID: this.recordGUID,
        stars: this.currentStars, // 星级
        tips: '[]'
      })
      this.step = 4
    },
    // 扫描创建
    async scanstartVedio (divId) {
      // 启动高拍仪
      console.log('启动高拍仪')
      const stream = await this.$jsMediaDevices.getVideoMedia(
        this.videoSetting['scan'].deviceId,
        {
          height: 1080,
          width: 1920
        }
      )
      this.scanaddMediaStreamToDiv(divId, stream, true)
    },
    scanaddMediaStreamToDiv (divId, stream, isLocal) {
      var video = document.createElement('video')
      const container = document.getElementById(divId)
      video.width = 960
      video.height = 540
      video.muted = isLocal
      video.style.verticalAlign = 'middle'
      container.innerHTML = ''
      container.appendChild(video)
      video.autoplay = true
      video.srcObject = stream
      return divId
    },
    takePicture (sourceId) {
      let canvas = document.createElement('canvas')
      let sourceObject = document
        .getElementById(sourceId)
        .getElementsByTagName('video')[0]
      canvas.width = 960
      canvas.height = 540
      let ctx = canvas.getContext('2d')
      ctx.drawImage(sourceObject, 0, 0, canvas.width, canvas.height)
      this.sourceObject = sourceObject
      this.canvas = canvas
      return canvas.toDataURL('image/jpeg')
    },
    getScanning () {
      const nowPreview = this.takePicture('scan')
      this.materiallist.push(nowPreview)
      this.uploadImg(nowPreview).then(r => {
        this.uploadedUrl.push(r)
      })
    },
    deletePhoto (index, list) {
      removeByValue(list, list[index])
    },
    sendToLawyer (arr) {
      // 关闭模态框
      // 发送逻辑
      easyrtc.sendDataWS(this.nowEasyrtcid, 'scanResult', JSON.stringify(arr))
      this.closeDialog()
      this.alert.info = '提交成功'
      this.alert.show = true
    },
    sendToLawyerClick (arr) {
      if (!arr.length) {
        return
      }
      this.$loading.show()
      if (
        arr.every(val => val !== false) &&
        arr.length === this.materiallist.length
      ) {
        console.log('上传成功')
        window.setTimeout(() => {
          this.$loading.hide()
          this.sendToLawyer(arr)
        }, 1500)
      } else {
        // loading... 不允许进行任何操作
        this.$loading.show()
        let time = 0
        var intervalNum = window.setInterval(async () => {
          if (arr.every(val => val !== false)) {
            window.clearInterval(intervalNum)
            this.$loading.hide()
            this.sendToLawyer(arr)
          } else {
            this.alert.info = '网络异常，部分文件传输失败，正在重试，请稍等。'
            this.alert.show = true
            const tmp = []
            for (const n in this.materiallist) {
              tmp.push(this.uploadImg(this.materiallist[n]))
            }
            const res = await Promise.all(tmp)
            if (res) {
              this.$loading.hide()
              window.clearInterval(intervalNum)
              this.sendToLawyer(res)
            } else {
              // 提示用户（需要用户确定）：
              this.$loading.hide()
              window.clearInterval(intervalNum)
              this.infoupload = true
              this.infouploadtxt =
                '网络异常，文件发送失败，请联系现场工作人员。'
            }
          }
          if (time === 20) {
            window.clearInterval(intervalNum)
            this.$loading.hide()
            // 提示用户（需要用户确定）：网络较差，文件发送失败，请联系现场工作人员。
            window.clearInterval(intervalNum)
            this.infoupload = true
            this.infouploadtxt = '网络较差，文件发送失败，请联系现场工作人员。'
          } else {
            time++
          }
        }, 1000)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.content {
  padding: 1.2rem 2.65rem 0 2.94rem;
  display: flex;
  justify-content: space-between;

  .videoconsult {
    position: relative;
    width:520px;
    .default-lawyer{
      width 100%
      height 600px
      background rgba(255,255,255,0.3) url('/img/ui/lawyer_avatar.png') center center no-repeat
      border 2px solid rgba(255,255,255,0.3)
      border-radius:0.1rem;
    }
    .target-video-container {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius:0.1rem;
      transform: rotateY(180deg);
      video {
        width: 100%;
      }
    }

    .self-video-container {
      position: absolute;
      top: 0;
      right: 0px;
      width: 200px;
      z-index: 999;
      video {
        display:block;
        width: 100%;
        height: auto;
      }
    }
  }

  .info {
    height: 5rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.4rem;
    letter-spacing: 1px;
    color: #fff;
    .tip{
      margin-top:0.1rem;
      font-size:0.3rem;
    }
  }

  .intro {
    flex: 1;
    box-sizing: border-box;
    position: relative;
    padding-left: 0.99rem;
    font-size: 0.3rem;
    color: #fff;
    .lawyer {
      font-size: 0.4rem;
      line-height: 0.4rem;
      margin-top: 0.3rem;

      span {
        font-size: 0.28rem;
      }
    }

    .organ {
      font-size: 0.3rem;
      line-height: 0.3rem;
      margin-top: 0.29rem;
    }

    .voicestatus {
      font-size: 0.34rem;
      line-height:1.6;
      font-size:0.3rem;
      margin: 2.1rem 0 1.02rem 0.4rem;
      span {
        font-size: 0.32rem;
        color: #ffb23c;
      }
    }
    .btns{
      display flex
    }
    .button {
      width: 2.77rem;
      height: 0.9rem;
      background-color: #33c339;
      border-radius: 0.1rem;
      color: #fff;
      font-size: 0.34rem;
      text-align: center;
      line-height: 0.9rem;
      border: 0;
      &.active {
        margin-left: 0.3rem;
        background-color: #ec3839;
      }
    }
  }

  .evaluation {
    padding: 0.69rem;
    flex: 1;
    text-align: center;
    color: #fff;

    .title {
      font-size: 0.42rem;
    }

    .voicetime {
      line-height: 1;
      padding: 0.28rem 0 1rem 0;
      font-size: 0.26rem;

      span {
        color: #ffb23c;
      }
    }

    .evaluation-con {
      display: flex;
      justify-content: space-between;
      width: 8.8rem;
      margin: 0 auto;

      .item {
        width: 1.86rem;
        color: #fff;
        font-size: 0.3rem;

        .imgs {
          width: 0.94rem;
          height: 0.94rem;
          text-align: center;
          line-height: 0.94rem;
          margin: 0 auto 0.3rem auto;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.2);

          img {
            height: 0.45rem;
            object-fit: cover;
          }
        }

        &.active {
          .imgs {
            background-color: #09bd5c;
          }
        }
      }
    }

    .button {
      width: 2.7rem;
      height: 0.9rem;
      margin: 1.2rem auto 0 auto;
      background-color: #fc9d0b;
      border-radius: 0.1rem;
      color: #fff;
      font-size: 0.34rem;
      text-align: center;
      line-height: 0.9rem;
      border: 0;
    }
  }
}

.uploadinfo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999999999;

  .masks {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .infocontent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.08rem;
    padding: 0.3rem;
    width: 5rem;
  }

  .infotitle {
    font-size: 0.3rem;
    padding: 0 0 0.3rem 0;
    text-align: center;
  }

  .infotxt {
    text-align: center;
    font-size: 0.26rem;
  }

  button {
    display: block;
    margin: 0.2rem auto;
    width: 1.78rem;
    height: 0.46rem;
    background-color: #2f5ccd;
    border-radius: 0.1rem;
    color: #fff;
    border: 0;
    font-size: 0.3rem;
  }
}
</style>
